import React from 'react';
import ResponsiveDialog from '../../../utility/ResponsiveDialog';
import { connect } from 'react-redux';
import styles from './../../../../styles/sass/components/ProductTourModal.module.scss';
import ProductTourModalContent from './ProductTourModalContents';
import { updateProfile } from '../../../../actions/auth';
import { isMobile } from './../../../../lib/getDeviceSize';
import { togglePhoneNumberOauthModal } from '../../../../actions/dashboard';

interface Props {
  dispatch: Function;
  user: any;
  token: any;
}

export const ProductTourModal: React.FC<Props> = ({
  dispatch,
  user,
  token,
}) => {
  const handleClose = () => {
    dispatch(
      updateProfile(
        { onboarding: { ...user.onboarding, dashboardTourComplete: true } },
        token,
        false,
        true,
      ),
    );
    setTimeout(() => {
      // Open phoneNumber prompt after completing Dashboard Tour
      if (!user.phoneNumber) {
        dispatch(togglePhoneNumberOauthModal(true));
      }
    }, 500);
  };

  return (
    <ResponsiveDialog
      className={styles.productTourModalContainer}
      onClose={handleClose}
      open={!user.onboarding.dashboardTourComplete}
      hideCloseButton
      mediumLargerPaper={!isMobile()}
      mediumLargePaperMobile={isMobile()}
    >
      <ProductTourModalContent handleClose={handleClose} />
    </ResponsiveDialog>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.auth.user,
  token: state.auth.token,
});

export default connect(mapStateToProps)(ProductTourModal);
